import styled from 'styled-components';

export const TagsGroup = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
